module.exports = __webpack_public_path__ + "img/thumbnail_SandCat_m_normal.84c5a355.png";